import firebase from "firebase/app";
import "firebase/auth";
//import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FAPIKEY,
    authDomain: process.env.REACT_APP_FAUTHDOMAIN,
    //databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FPROJECTID,
    storageBucket: process.env.REACT_APP_FSTORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FMESSAGESENDERID,
    appId: process.env.REACT_APP_FAPPID,
    measurementId: process.env.REACT_APP_FMEASUREMENTID
};

const app = firebase.initializeApp(firebaseConfig);


export const auth = app.auth();
//export const database = app.database();
export const firestore = app.firestore();
export const storage = app.storage();
export default app;